import request from '@/utils/request';

//注册门店TOP5
export function registerShopSort(values) {
  return request('/allMarket/activityReport/queryRegisteredStoreTop', {
    method: 'POST',
    data: values,
  });
}

//购买门店TOP5
export function buyShopSort(values) {
  return request('/allMarket/activityReport/queryBuyStoreTop', {
    method: 'POST',
    data: values,
  });
}

//鞋类TOP5
export function shoeSort(values) {
  return request('/allMarket/activityReport/queryFootwearTop', {
    method: 'POST',
    data: values,
  });
}

//包类TOP5
export function packetSort(values) {
  return request('/allMarket/activityReport/queryBagTop', {
    method: 'POST',
    data: values,
  });
}

//新老会员参与分布
export function memberSpread(values) {
  return request('/allMarket/activityReport/queryMemberDistribution', {
    method: 'POST',
    data: values,
  });
}

//优惠券使用占比
export function cancellateUseRate(values) {
  return request('/allMarket/activityReport/queryCouponUsedPercentage', {
    method: 'POST',
    data: values,
  });
}

//查询活动详情
export function activityDetail(values) {
  return request('/allMarket/activityReport/queryActivityDetail', {
    method: 'POST',
    data: values,
  });
}

//优惠券核销率
export function cancellateRate(values) {
  return request('/allMarket/activityReport/queryCouponOffRate', {
    method: 'POST',
    data: values,
  });
}

//日注册趋势
export function registerDay(values) {
  return request('/allMarket/activityReport/queryDailyRegistrationTrend', {
    method: 'POST',
    data: values,
  });
}

//日访问趋势
export function visitedDay(values) {
  return request('/allMarket/activityReport/queryDailyVisitTrend', {
    method: 'POST',
    data: values,
  });
}

//活动数据基准时间
export function deadLineTime(values) {
  return request('/allMarket/activityReport/queryActivityDeadline', {
    method: 'POST',
    data: values,
  });
}

//新会员注册+销售追踪
export function newMemberRegister(values) {
  return request('/allMarket/activityReport/queryNewMemberTracking', {
    method: 'POST',
    data: values,
  });
}
//新会员注册+销售追踪
export function jumpApplet(values) {
  return request('/allMarket/activityReport/queryJumpApplet', {
    method: 'POST',
    data: values,
  });
}

//访问会员销售追踪
export function visitedMemberSall(values) {
  return request('/allMarket/activityReport/queryAccessMemberTracking', {
    method: 'POST',
    data: values,
  });
}

//导出活动明细数据
export function exportActivityDetail(values) {
  return request('/allMarket/activityReport/exportActivityDetail', {
    method: 'POST',
    data: values,
  });
}
